import { RechargeService } from './../../../services/recharge.service';
import { AuthService } from './../../../providers/auth.service';
import { Component } from '@angular/core';
import { NavParams, ViewController } from 'ionic-angular';
import { InAppBrowser } from '@ionic-native/in-app-browser';
import { AlertService } from "./../../../providers/alert.service";

/*
  充值
*/
@Component({
    selector: 'page-miaokatong',
    templateUrl: 'miaokatong.html',
    providers: [RechargeService,AlertService]
})
export class RechargeMiaoKaTong {

    constructor(
        private navPar: NavParams,
        private viewCtrl: ViewController,
        private auth: AuthService,
        private iab: InAppBrowser,
        private rechargeService: RechargeService,
        private alert:AlertService,
    ) { }

    info = this.navPar.data;
    banks = [];
    isShowBank = this.info.BankCode; 
    redirectUrl = '';

    ngOnInit() {
        if (this.info && this.info.CurrBankCode != 'Guangshun' && this.info.CurrBankCode != 'Huitfwy') {
            this.info.BankCode = 'ICBC';
        }
        this.getUrl();
    }

    //获取跳转路径
    //TQQ 2017-08-28
    getUrl() {
        let par = {
            recordId: this.info.RecodeID,
            bankco: this.info.BankCode,
            Authorization: this.auth.getToken()
        };
        this.rechargeService.rechargePost(par).then(s => {
            if (s.Result) {
                this.redirectUrl = s.Error;
            }
        });
    }

    //进入第三方支付
    //TQQ 2017-01-04
    payClick() {
        if(this.info.BankCode){
            this.iab.create(this.redirectUrl, '_system');
        }else{
            this.alert.showAlert('请先选择付款银行');
        }
    }

    //页面返回
    //chen 2017-01-19
    close() {
        this.viewCtrl.dismiss();
    }

    openNewSpecifiedWindow(windowName) {
        window.open('about:blank', windowName, 'width=700,height=400,menubar=no,scrollbars=no');
    }

}



// WEBPACK FOOTER //
// ./src/pages/recharge/miaokatong/miaokatong.ts